export default __webpack_public_path__ + "static/media/avatar5.2b7fa26b.svg";